module.exports = __webpack_public_path__ + "fonts/iconfont.f87689d0.woff";